/**
 * 私有路由组件
 * 保护需要认证的路由
 */

import { Navigate } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'
import { Spin } from 'antd'
import { useEffect, useState } from 'react'

interface PrivateRouteProps {
  children: React.ReactNode
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const { isAuthenticated, checkAuth } = useAuthStore()
  const [isChecking, setIsChecking] = useState(true)

  useEffect(() => {
    const check = async () => {
      await checkAuth()
      setIsChecking(false)
    }
    check()
  }, [checkAuth])

  if (isChecking) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh' 
      }}>
        <Spin size="large" tip="加载中..." />
      </div>
    )
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" replace />
}

export default PrivateRoute

